module.exports = __webpack_public_path__ + "static/media/e-Boks Sandbox Service Guide 1.01.1d63d4bd.pdf";